import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
export function LocalLaunch() {
  const {
    t
  } = useLanguage();
  return <section className="py-32 lg:py-48 bg-texture-espresso text-cream border-y border-cream/5" data-id="element-153">
      <div className="max-w-[1400px] mx-auto px-8 lg:px-14 grid lg:grid-cols-12 gap-12 lg:gap-20 items-center" data-id="element-154">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1
      }} className="lg:col-span-6" data-id="element-155">
          <div className="flex items-center gap-3 text-caramel text-[10px] tracking-[0.4em] uppercase mb-10" data-id="element-156">
            <span className="w-10 h-px bg-caramel/40" data-id="element-157" />
            {t.localLaunch.eyebrow}
          </div>
          <h2 className="font-serif text-5xl sm:text-6xl lg:text-7xl text-cream leading-[0.95] tracking-[-0.02em] font-light" data-id="element-158">
            {t.localLaunch.title1}
            <br data-id="element-159" />
            <span className="italic font-extralight" data-id="element-160">
              {t.localLaunch.title2}
            </span>
          </h2>
          <p className="mt-10 text-cream/60 leading-[1.8] text-[15px] max-w-md" data-id="element-161">
            {t.localLaunch.copy}
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1,
        delay: 0.15
      }} className="lg:col-span-6" data-id="element-162">
          <div className="relative" data-id="element-163">
            <div className="relative h-64 lg:h-80 bg-chocolate/60 border border-cream/10 overflow-hidden" data-id="element-164">
              <svg className="absolute inset-0 w-full h-full" viewBox="0 0 600 320" preserveAspectRatio="none" aria-hidden data-id="element-165">
                {[...Array(14)].map((_, i) => <path key={i} d={`M -50 ${30 + i * 22} Q 150 ${10 + i * 22} 300 ${40 + i * 22} T 650 ${20 + i * 22}`} fill="none" stroke="#F7F0E8" strokeOpacity={0.08} strokeWidth="1" data-id="element-166" />)}
              </svg>
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-167">
                <div className="relative" data-id="element-168">
                  <span className="absolute inset-0 rounded-full bg-caramel/30 animate-ping" data-id="element-169" />
                  <span className="relative block w-2.5 h-2.5 rounded-full bg-caramel" data-id="element-170" />
                </div>
              </div>
              <span className="absolute bottom-4 left-6 text-[10px] tracking-[0.3em] uppercase text-cream/40" data-id="element-171">
                30°12′N — 95°45′W
              </span>
            </div>

            <div className="mt-10 grid grid-cols-2 gap-8" data-id="element-172">
              {t.localLaunch.points.map(p => <div key={p.label} data-id="element-173">
                  <p className="text-[10px] tracking-[0.3em] uppercase text-cream/40 mb-3" data-id="element-174">
                    {p.label}
                  </p>
                  <p className="font-serif text-xl text-cream font-light" data-id="element-175">
                    {p.value}
                  </p>
                </div>)}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}